import { getUsagePercent } from 'src/common/utils/getUsagePercent';
import {
  CREDIT_LIMIT_APPROACHING_THRESHOLD,
  MAX_CREDIT_LIMIT_PERCENTAGE,
} from 'src/components/selfService/common/Balance/constants/balanceConstants';
import {
  BalanceAccountStatus,
  BalanceCreditInfoApiResponse,
} from 'src/types/Balance';

export enum BalanceCreditLimitStatus {
  OK = 'ok',
  SUSPENDED = 'suspended',
  LIMIT_APPROACHING = 'limitApproaching',
}

export const getBalanceCreditLimitStatus = (
  creditInfo: BalanceCreditInfoApiResponse
): BalanceCreditLimitStatus => {
  if (creditInfo.accountStatus === BalanceAccountStatus.ACTIVE) {
    const usedCreditLimitPercentage = getUsagePercent(
      creditInfo.creditLimit - creditInfo.availableCredit,
      creditInfo.creditLimit
    );

    const isApproachingLimit =
      usedCreditLimitPercentage > CREDIT_LIMIT_APPROACHING_THRESHOLD &&
      usedCreditLimitPercentage < MAX_CREDIT_LIMIT_PERCENTAGE;

    if (isApproachingLimit) {
      return BalanceCreditLimitStatus.LIMIT_APPROACHING;
    }

    return BalanceCreditLimitStatus.OK;
  }

  return BalanceCreditLimitStatus.SUSPENDED;
};
